import ElProgress from 'element-plus/es/el-progress'
export default ElProgress
